import React, { useState } from "react";
import "./VideoCard.css";

// Helpers (unchanged)
function getEmbedUrl(rawUrl) {
  try {
    const u = new URL(rawUrl);
    if (u.hostname.includes("youtube.com")) {
      const v = u.searchParams.get("v");
      return `https://www.youtube.com/embed/${v}`;
    }
    if (u.hostname === "youtu.be") {
      return `https://www.youtube.com/embed/${u.pathname.slice(1)}`;
    }
    if (u.hostname.includes("vimeo.com")) {
      const id = u.pathname.split("/").filter(Boolean).pop();
      return `https://player.vimeo.com/video/${id}`;
    }
  } catch {}
  return rawUrl;
}
function getYoutubeThumb(rawUrl) {
  try {
    const u = new URL(rawUrl);
    let vid = "";
    if (u.hostname.includes("youtube.com")) vid = u.searchParams.get("v") || "";
    if (u.hostname === "youtu.be") vid = u.pathname.slice(1);
    return vid ? `https://img.youtube.com/vi/${vid}/hqdefault.jpg` : "";
  } catch {
    return "";
  }
}

export default function VideoCard({
  title,
  date,
  tags = [],
  description,
  src,
  thumbnail = "",
}) {
  const [playing, setPlaying] = useState(false);
  const embedUrl = getEmbedUrl(src);
  const thumbUrl = thumbnail || getYoutubeThumb(src);

  return (
    <div className="vc-card">
      <div className="vc-thumb-wrapper" onClick={() => setPlaying(true)}>
        {playing ? (
          <iframe
            className="vc-video-iframe"
            src={embedUrl}
            title={title}
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
          />
        ) : (
          <>
            <img className="vc-thumbnail" src={thumbUrl} alt={title} />
            <div className="vc-tags-overlay">
              {tags.map((tag, i) => (
                <span key={i} className="vc-tag">
                  {tag}
                </span>
              ))}
            </div>
            <div className="vc-play-overlay">
              <div className="vc-play-icon">▶</div>
            </div>
          </>
        )}
      </div>

      <h3 className="vc-title">{title}</h3>
      <p className="vc-date">{date}</p>
      {description && <div className="vc-description">{description}</div>}
    </div>
  );
}
